import { useTranslation } from "react-i18next";
import { Beer } from "lucide-react";
import {
  Dialog,
  DialogClose,
  DialogContent,
  DialogDescription,
  DialogFooter,
  DialogHeader,
  DialogTitle,
} from "@/components/ui/dialog";
import { Button } from "@/components/ui/button";

interface SupportDialogProps {
  open: boolean;
  onOpenChange: (open: boolean) => void;
}

export function SupportDialog({ open, onOpenChange }: SupportDialogProps) {
  const { t } = useTranslation();

  return (
    <Dialog open={open} onOpenChange={onOpenChange}>
      <DialogContent className="w-[calc(100%-2rem)] max-w-md rounded-lg">
        <DialogHeader className="items-center text-center sm:text-center">
          <div className="mb-2 flex h-12 w-12 items-center justify-center rounded-full bg-primary/10 text-primary">
            <Beer className="h-6 w-6" aria-hidden="true" />
          </div>
          <DialogTitle>{t("support_dialog.title")}</DialogTitle>
          <DialogDescription>{t("support_dialog.description")}</DialogDescription>
        </DialogHeader>
        <DialogFooter className="gap-2 sm:justify-center sm:space-x-0">
          <DialogClose asChild>
            <Button variant="ghost">{t("support_dialog.later")}</Button>
          </DialogClose>
          <Button asChild>
            <a href="https://buymeacoffee.com/smiethi" target="_blank" rel="noopener noreferrer">
              <Beer aria-hidden="true" />
              {t("support_dialog.action")}
            </a>
          </Button>
        </DialogFooter>
      </DialogContent>
    </Dialog>
  );
}